import { render } from "./Team_post_investment_en_m.vue?vue&type=template&id=b0fe1450&scoped=true"
import script from "./Team_post_investment_en_m.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_en_m.vue?vue&type=script&lang=js"

import "./Team_post_investment_en_m.vue?vue&type=style&index=0&id=b0fe1450&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0fe1450"

export default script